module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"block.default":"ไม่สามารถแก้ไขได้"}}')
  delete Component.options._Ctor
}
